import { createDomain } from 'effector-root';

const domain = createDomain('Shipping Routes (Page)');

export const onPageStarted = domain.event();